/** Empty: the homepage lives at the locale root (`/es`), which switches the SEO helper to pathless mode. */
export const routeName = '';
export const slugs: Record<string, string> = {};
export const sitemap = { changefreq: 'weekly', priority: '1.0', lastmod: '2026-08-21' };
